import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Typography
} from '@mui/material';
import React, { useCallback } from 'react';
import { IContentFieldProps } from 'types/fields';

interface IIdPInputCheckboxProps extends Omit<
	IContentFieldProps,
	'value' | 'onChange'
> {
	value: boolean | null;
	onChange: (value: boolean) => void;
	helperText?: string;
}

const IdPInputCheckbox: React.FC<IIdPInputCheckboxProps> = ({
	name,
	displayName,
	disabled,
	value,
	onChange,
	error = undefined,
	helperText = undefined
}) => {
	const handleChange = useCallback(
		(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
			onChange(checked);
		},
		[onChange]
	);

	return (
		<FormControl disabled={disabled} error={Boolean(error)}>
			<FormControlLabel
				name={name}
				label={<Typography variant="body1">{displayName}</Typography>}
				control={
					<Checkbox
						data-testid="field-checkbox"
						checked={!!value}
						onChange={handleChange}
					/>
				}
			/>
			{(error || helperText) && (
				<FormHelperText>{error || helperText}</FormHelperText>
			)}
		</FormControl>
	);
};

export default IdPInputCheckbox;
